import Panel from '~/components/Panel'

const DetailsDigitalSignage: React.FC<ViewCampaignProps> = ({ data }) => {
  const videoUrl = data?.ads?.data?.[0]?.settings?.media_url

  return (
    <Panel title="Mídia da campanha">
      <video controls className="vh-50 border border-1 border-tertiary">
        <source src={videoUrl} type="video/mp4" />
      </video>
    </Panel>
  )
}

export default DetailsDigitalSignage
